module.exports = __webpack_public_path__ + "static/media/bg.1607cb24.png";


//////////////////
// WEBPACK FOOTER
// ./src/vehicleInquiry/index/images/bg.png
// module id = 1588
// module chunks = 0